import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Volgers',
  fields: {
    name: 'Naam:',
    email: 'E-mail:',
    phone_number: 'Telefoon:',
    subscribed: 'Ingeschreven:',
    birthday: 'Verjaardag:',
    location: 'Locatie:',
    followed: 'Gevolgd:',
    lifetime_spent: 'Totaal besteed:',
    total_orders: 'Totaal bestellingen:',
    google_review: 'Google-review:',
    loyalty_lifetime: 'Loyaliteit totaal:',
    loyalty_points: 'Loyaliteit vandaag:',
  },
  labels: {
    yes: 'Ja',
    no: 'Nee',
    followed_since_date: 'Sinds {{date}}',
  },
  buttons: {
    edit: 'Bewerken',
    request_data_deletion: 'Gegevensverwijdering aanvragen',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
  tabs: {
    recent_orders: {
      title: 'Recente bestellingen',
      columns: {
        order_id: 'Id',
        items: 'Artikelen',
        total: 'Totaalbedrag',
        paid_on: 'Betaald op',
        payment_method: 'Betaalmethode',
      },
      labels: {
        no_orders: 'Nog geen bestellingen',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Kaart',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Bankafschrijving',
        [PaymentMethods.CASH]: 'Contant',
        [PaymentMethods.BACS_DEBIT]: 'Bankafschrijving',
      },
    },
    messages: {
      title: 'Berichten',
      columns: {
        template: 'Sjabloon',
        status: 'Status',
        opened: 'Geopend',
        clicked: 'Geklikt',
        spam_complaint: 'Spamklacht',
        unsubscribed: 'Uitgeschreven',
        sent_at: 'Verzonden op',
      },
      labels: {
        yes: 'Ja',
        no: 'Nee',
        not_detected: 'Niet gedetecteerd',
        opened_at: 'Geopend op {{date}}',
        clicked_at: 'Geklikt op {{date}}',
        complained_at: 'Geklaagd op {{date}}',
        unsubscribed_at: 'Uitgeschreven op {{date}}',
        no_messages: 'Nog geen berichten',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Verzonden',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Afgeleverd',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Mislukt',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Gegevens laden mislukt',
      },
    },
    balance_history: {
      title: 'Puntengeschiedenis',
      columns: {
        created_at: 'Datum',
        source: 'Bron',
        value: 'Punten',
        points_expire_at: 'Vervalt op',
      },
      labels: {
        source: {
          welcome_bonus: 'Welkomstbonus',
          google_review_reward: 'Google-reviewbeloning',
          reward_loyalty_program_conversion: 'Conversiebonus loyaliteitsprogramma',
          cashback: 'Cashback',
          refund: 'Terugbetaling',
          cashback_usage: 'Cashbackgebruik',
          cashback_usage_refund: 'Terugbetaling cashbackgebruik',
          expired_points_void: 'Verlopen punten vervallen',
          mobile_app_signup_bonus: 'Aanmeldbonus mobiele app',
        },
        no_operations: 'Nog geen transacties',
      },
    },
  },
};
